/* 🤖 this file was generated by svg-to-ts */
export const iconUsdg: {
  name: 'usdg';
  data: string;
} = {
  name: 'usdg',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#globaldollar__clip0_2940_1948)"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m1.42 27.81C7.57 28.9.71 18.34 5.84 9.82c5.01-8.33 17.52-7.32 21.19 1.67.47 1.14.72 2.34.86 3.57h-5.7c.15-.32.3-.66.42-1 1.78-5.05-1.01-7.56-5.74-4.95-3.14 1.73-6.25 5.41-7.44 8.8-1.82 5.18 1.08 7.58 5.83 4.9 1.6-.9 3.05-2.21 4.23-3.61l-2.59-1.11v-1.18h10.99c-.43 5.58-4.88 10.27-10.46 10.89z"/></g><defs><clipPath id="globaldollar__clip0_2940_1948"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
